import {IRestriction} from './IRestriction';

declare const THREE: any;

export class RangeRestriction implements IRestriction {

  private tmp = new THREE.Vector3();

  private static isBetweenPoints(start, end, pointToCheck) {
    const ab = start.clone().sub(pointToCheck).normalize();
    const bc = end.clone().sub(pointToCheck).normalize();
    return ab.dot(bc) <= 0.1;
  }

  check(post, newPosition, edge: Feeney.IEdge): boolean {
    this.tmp.copy(newPosition).setY(0);
    return RangeRestriction.isBetweenPoints(edge.start, edge.end, this.tmp);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/MoveObjectComponent/MovePostRestrictions/RangeRestriction.ts